import * as React from 'react';

// progress
import Loader from 'react-loader'

const SimpleLoader = props => {
    function Sloader(prop) {
        // const visible = prop.vi;
        if (!props.loaded) {
          return <Loader color="#3EE9F7" loaded={false}/>;
        }
        return <div/>;
      }
    return (  
        <Sloader/>
    )
  };

  export default SimpleLoader;


// WEBPACK FOOTER //
// ./src/common/simpleLoader.Component.tsx